<template>
  <div>
    <div v-if="load_show">
      <load></load>
    </div>
    <!-- header-->
    <div class="main_share">
      <!-- 搜索框 -->
      <el-row >
        <el-input placeholder="搜索提问内容" prefix-icon="el-icon-search" @keyup.enter.native="search_click()" v-model.trim="search" style="width: 90%;margin: 0 5%;"></el-input>
        <el-row style="width: 90%;margin: 0 5%;">
            <div v-for="(item,index) in consult_list.data" :key="index"  @click="see_info(item.num)"  style=" border-bottom: 1px solid #EBEEF5;padding: 12px 0;">
              <img v-if="item.new" style="width: 10px; height: 10px; margin-right: 0.625rem;" src="../../../assets/red.jpg"/>
              <span>{{item.content}}</span>
            </div>
        </el-row>
      </el-row>
    </div>
  </div>
</template>

<script>
  import load from '../../../components/load.vue';
  export default {
    data() {
      return {
        load_show:'',
        consult_list:{
          data:[],
        },
        search: '',
      }
    },
    components: {
      load:load

    },
    mounted:function(){
      this.dialog_height=document.documentElement.clientHeight * 0.5+'px'
      this.save_info()
    },
    methods: {
      save_info(){
        let _this=this
        if(_this.$route.query.hasOwnProperty('openid')){
          let data=_this.$route.query
          localStorage.setItem('share_consult_type',data.type)
          localStorage.setItem('share_consult_num',data.num)
          localStorage.setItem('share_consult_openid',data.openid)
        }
        if(_this.$route.query.hasOwnProperty('msg')){
          _this.see_info(_this.$route.query.msg)
        }else{
          _this.get_consult_list()
        }

      },
      see_info(num){
        let _this=this
        _this.$router.push({path: '/share_consult_info', query: {msg:num,type:_this.$route.query.type,
        openid:_this.$route.query.openid,num:_this.$route.query.num}})
        // _this.$router.push({path: '/share_consult_info', query: {num:num,type:localStorage.getItem('share_consult_type'),
        // num:localStorage.getItem('share_consult_num'),openid:localStorage.getItem('share_consult_openid')}})
      },
      search_click(){
        let _this=this
        _this.get_consult_list()
      },
      get_consult_list(){
        let _this=this
        _this.load_show=true
        _this.axios.get('/v2/temp/wx_gxp_list',{params:{keyword:_this.search,type:localStorage.getItem('share_consult_type'),
        num:localStorage.getItem('share_consult_num'),openid:localStorage.getItem('share_consult_openid')
        }}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.load_show=false
              _this.consult_list.data=res.data.data.list
            }else{
              _this.$message.error(res.data.msg)
              _this.load_show=false
            }
          }else{
            _this.$message.error('服务器内部错误')
            _this.load_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        });
      },
    },
  }
</script>

<style scoped>
  .twoLineCls{
    cursor: pointer;
  	text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
       text-overflow: ellipsis;
       display: -webkit-box;
       -webkit-line-clamp: 2;
       line-clamp: 2;
       -webkit-box-orient: vertical;
  }

  .header_div {
    z-index: 9999;
  }

  .main_share {
    min-height: calc(100vh) ;
    width: 100%;
    padding: 20px  0;
    z-index: 100;
    background-color: white;
  }

  .title {
    padding: 20px;
    overflow: hidden;

  }

  h1 {
    margin: 0;
  }

  /* 分页 */
  .block {
    margin: 30px 0;
  }
  .over{
    overflow: auto;
    padding: 0 1.25rem;
    margin-bottom: 0.625rem;
    margin-top: 0.625rem;
  }
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(154, 155, 158);
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/view/share/consult_teacher/consult.vue